.snooze-animation {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.1);
    text-align: center;
    border-radius: 50%;
    // z-index: 1;
}

.snooze-animation span {
    font-size: 2rem;
    font-weight: bold;
    color: rgba(255, 255, 255, 0.9);
    border-width: 1px;
    animation: snooze-animation 6s linear infinite;
    text-shadow: 0 0 5px rgba(56, 56, 56, 0.726), 0 0 10px rgba(197, 197, 197, 0.692);

    position: absolute;
    bottom: 0;
}

.snooze-animation span:nth-child(1) {
    animation-delay: -3.6s;
}

.snooze-animation span:nth-child(2) {
    animation-delay: -2.4s;
}

.snooze-animation span:nth-child(3) {
    animation-delay: -1.2s;
}

.snooze-animation span:nth-child(4) {
    animation-delay: 0s;
}

@keyframes snooze-animation {

    0% {
        transform: translate(0, 0) scale(0.2) rotate(0deg);
        opacity: 0;
    }

    3% {
        opacity: 1;
    }

    33% {
        transform: translate(200%, -50%) scale(0.5) rotate(3deg);
    }

    50% {
        transform: translate(150%, -75%) scale(0.65) rotate(0deg);
    }

    66% {
        transform: translate(0, -100%) scale(0.8) rotate(-3deg);
    }

    75% {
        opacity: 1;
    }

    100% {
        transform: translate(200%, -160%) scale(1) rotate(0deg);
        opacity: 0;
    }
}